import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';

interface CertificationActionsMenuProps {
  isOpen: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
  position: { top: number; right: number };
}

const CertificationActionsMenu: React.FC<CertificationActionsMenuProps> = ({
  isOpen,
  onEdit,
  onDelete,
  onClose,
  position,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className={classes.actionsMenu}
      style={{ top: position.top, right: position.right }}
      data-testid="my-certification-actions-menu"
    >
      <button
        className={classes.actionsMenuItem}
        data-testid="my-certification-edit-button"
        onClick={e => {
          e.stopPropagation();
          onEdit();
          onClose();
        }}
      >
        {t('common.edit')}
      </button>
      <button
        className={classes.actionsMenuItem}
        data-testid="my-certification-delete-button"
        onClick={e => {
          e.stopPropagation();
          onDelete();
          onClose();
        }}
      >
        {t('common.delete')}
      </button>
    </div>
  );
};

export default CertificationActionsMenu;
